module.exports = __webpack_public_path__ + "img/bs5.dfa83765.png";